import { useEffect, useState } from 'react';
import { Modal } from '@shared/components';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import Loader from '@components/Loader/ui/Loader';
import DocGif from '@icons/GeneratingDocIcon/GeneratingDocIcon.gif';
import styles from './index.module.scss';

/**
 * @description a modal for Generating demand.
 */

function TemplateGeneratingModal() {
  const [minimized, setMinimized] = useState(false);
  const { values, setValues } = usePageContext();

  useEffect(() => {
    let minimizedTimer: any;
    if (values?.generateTemplateModalOpened) {
      minimizedTimer = setTimeout(() => {
        setMinimized(true);
      }, 4000);
    }
    return () => {
      if (minimizedTimer) {
        clearTimeout(minimizedTimer);
        setMinimized(false);
      }
    };
  }, [values?.generateTemplateModalOpened]);

  const onMinimizeClick = () => {
    setMinimized(true);
  };

  const onCloseClick = () => {
    if (setValues) {
      setValues((prev) => ({ ...prev, generateTemplateModalOpened: false }));
    }
  };

  return (
    <Modal
      showModal={values?.generateTemplateModalOpened!}
      modalClassname={minimized ? styles.modalMinimized : undefined}
      modalBaseClassname={minimized ? styles.modalBaseMinimized : undefined}
    >
      <div
        className={[styles.layout, minimized && styles.minimizedLayout].join(
          ' '
        )}
      >
        <div>
          <img className={styles.icon} src={DocGif} alt="Loading..." />
        </div>
        <div className={styles.infoBlock}>
          <div className={styles.text}>
            <p className={styles.title}>Creating your Document Template</p>
            <p className={styles.description}>
              It takes around 20-25 mins for us to write your document template
            </p>
          </div>
          {!minimized && <div className={styles.line} />}
          <div className={styles.loader}>
            <Loader size={15} />
            <p className={styles.subDescription}>
              Analyzing hundreds of documents
            </p>
          </div>
        </div>
        <button
          type="button"
          className={styles.actions}
          onClick={onMinimizeClick}
        >
          Minimize window
        </button>
        {minimized && (
          <button type="button" className={styles.close} onClick={onCloseClick}>
            <span />
          </button>
        )}
      </div>
    </Modal>
  );
}

export default TemplateGeneratingModal;
